<section class="Experts">
  <div class="experts-big-text">
    <p>
      <span class="highlight">{{ "about.header.highlight" | translate }}</span
      >{{ "about.header.title1" | translate }}
      <span class="captional-text">{{ "about.header.bold" | translate }}</span
      ><span class="addition-text">{{
        "about.header.title2" | translate
      }}</span>
    </p>
  </div>
  <div class="exp-experts-text">
    <p>
      <span class="exp-rectangle"></span
      >{{ "about.header.subtitle1" | translate }}
    </p>
    <p>
      <span class="exp-rectangle"></span
      >{{ "about.header.subtitle2" | translate }}
    </p>
  </div>
  <button
    routerLink="/offers"
    routerLinkActive="active"
    class="experts-button"
    id="btn-know-offerts"
  >
    {{ "about.header.button" | translate }} →
  </button>
</section>

<section class="form">
  <div class="experts-description">
    <div class="upper-side">
      <div class="mobile-element"></div>
      <h2 class="whiteTitle">{{ "about.expert.title" | translate }}</h2>
      <hr />
    </div>
    <div class="text-side whiteParagraph">
      {{ "about.expert.subtitle" | translate }}
    </div>
  </div>
</section>

<section class="about-us">
  <article class="article-who">
    <div class="experts-text">
      <div class="mobile-element-exp"></div>
      <h2>
        {{ "about.about.title" | translate }}
        <hr />
      </h2>
    </div>
    <div class="experts-description-text">
      <p>
        {{ "about.about.subtitle" | translate }}
      </p>
      <p>
        {{ "about.about.subtitleA" | translate }}
      </p>
    </div>
    <a target="_blank" href="assets/pdf/2025_Omex_ang.pdf"
      ><button class="experts-btn wrtie-to-us">
        {{ "about.about.button1" | translate }} →
      </button></a
    >
  </article>

  <section class="exp-elements">
    <div class="row-elements">
      <div class="first-element"></div>
      <div id="element-anim" class="second-element"></div>
    </div>
    <div class="col-elements">
      <div class="third-element"></div>
      <div class="fourth-element"></div>
    </div>
  </section>
</section>

<section class="why-omex">
  <aside>
    <div class="why-omex-title">
      <div class="mobile-element-why"></div>
      <h2>
        {{ "about.about.title1" | translate }}
        <hr />
      </h2>
    </div>
    <div class="why-omex-exp-elements">
      <div class="why-omex-col-elements">
        <div class="why-omex-first-element"></div>
        <div class="why-omex-second-element"></div>
      </div>
      <div class="why-omex-row-elements">
        <div class="why-omex-third-element"></div>
        <div class="why-omex-fourth-element"></div>
      </div>
    </div>
  </aside>
  <article>
    <span>{{ "about.about.subtitle1" | translate }}</span>
    <p>
      {{ "about.about.text1" | translate }}<br />
      {{ "about.about.text1a" | translate }}<br />
      {{ "about.about.text1b" | translate }}
    </p>
    <div class="mobile-element-gray-space"></div>
    <span>{{ "about.about.subtitle2" | translate }}</span>
    <p>
      {{ "about.about.text2" | translate }}<br />
      {{ "about.about.text2a" | translate }}<br />
      {{ "about.about.text2b" | translate }}
    </p>
    <div class="mobile-element-gray-space"></div>
    <span>{{ "about.about.subtitle3" | translate }}</span>
    <p>
      {{ "about.about.text3" | translate }}<br />
      {{ "about.about.text3a" | translate }}<br />
    </p>
    <div class="mobile-element-gray-space"></div>
    <span>{{ "about.about.subtitle4" | translate }}</span>
    <p>
      {{ "about.about.text4" | translate }}<br />
      {{ "about.about.text4a" | translate }}<br />
    </p>
    <div class="mobile-element-gray-space"></div>
  </article>
</section>

<section class="contact-us">
  <div class="hero">
    <span
      ><span class="highlight"
        >{{ "about.form.question" | translate }} <br /></span
      ><br class="mob-br" /><span class="text-thin"
        >{{ "about.form.answer" | translate
        }}{{ "about.form.answer1" | translate }}</span
      ><br class="mob-br" /><br /><span class="captional-text"
        >{{ "about.form.contact" | translate }}<br class="mob-br" />
        {{ "about.form.contact1" | translate }}</span
      ></span
    >
    <hr />
    <p>
      {{ "about.form.text1" | translate }} <span class="rectangle"></span>
      {{ "about.form.text2" | translate }} <span class="rectangle"></span>
      {{ "about.form.text3" | translate }}
    </p>

    <button
      class="contact wrtie-to-us"
      routerLink="/contact"
      routerLinkActive="active"
    >
      {{ "about.form.button" | translate }} →
    </button>
  </div>
</section>
